import * as Yup from 'yup'
import { type AuthenticationSource } from '../user/AuthenticationSource'

export interface LoginResponse {
  accessToken: string
  assetHolderId: number
  userProfileName: string
  userSettlementsEnabled: boolean
  userPendingSettlementsAvailable: boolean
}

export interface AuthenticationCheck {
  isAuthenticated: boolean
}

export interface LoginPayload {
  emailAddress: string
  password: string
  context: AuthenticationSource
}

export const validateLoginPayload = (): any => {
  return Yup.object().shape({
    emailAddress: Yup.string()
      .email('Please enter a valid email address')
      .required('Please enter your email address'),
    password: Yup.string().required('Please enter your password')
  })
}

export const validateResetPasswordPayload = (): any => {
  return Yup.object().shape({
    username: Yup.string()
      .email('Please enter a valid email address')
      .required('Please enter your email address'),
    password: Yup.string().required('Please enter your password'),
    confirmationPassword: Yup.string().required('Please enter your confirmation password')
      .oneOf([Yup.ref('password')], 'The password and confirmation must match')
  })
}
